export function FunPage() {
  return (
    <section className="simple-page">
      <h1>Fun and Games</h1>
      <p>toys and fun things will go here.</p>
      <p>stay tuned.</p>
    </section>
  );
}
